import React from "react";
import { SectionHeading } from "./SectionHeading";
import { Eye, MousePointerClick, MessageCircle } from "lucide-react";

const steps = [
  { icon: Eye, title: "Browse the Collection", desc: "Explore our Gold, Silver & other jewellery sections at your own pace." },
  { icon: MousePointerClick, title: "Click Your Favourite Piece", desc: "Tap on any item card that catches your eye — rings, bracelets & more." },
  { icon: MessageCircle, title: "Chat With Us on WhatsApp", desc: "WhatsApp opens instantly with your enquiry ready to send to our team." },
];

export const HowItWorks = () => (
  <section className="relative py-20 sm:py-28 bg-background overflow-hidden">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Simple Process"
        title="How It Works"
        subtitle="No accounts, no waiting — just browse and connect with us directly."
      />
      <div className="relative grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-8">
        <div className="hidden sm:block absolute top-8 left-[16%] right-[16%] divider-gold" aria-hidden="true" />
        {steps.map((step, idx) => (
          <div key={idx} className="relative flex flex-col items-center text-center">
            <div className="relative z-10 h-16 w-16 rounded-full bg-card border-2 border-primary/40 flex items-center justify-center shadow-card-lux mb-5">
              <step.icon className="h-7 w-7 text-primary" />
              <span className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-primary text-primary-foreground text-xs font-semibold flex items-center justify-center">
                {idx + 1}
              </span>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground">{step.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed max-w-xs">{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
